import { BaseAPI } from './base';
import type { StaffItem } from '../../types/entity/staff';
import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';

export class StaffAPI extends BaseAPI<StaffItem> {
  constructor() {
    super('/staffs');
  }

  async updateRoles(id: number | string, roleIds: number[]): Promise<BaseResponse<void>> {
    const response = await apiClient.post<BaseResponse<void>>(`${this.endpoint}/${id}/roles`, {
      role_ids: roleIds,
    });
    return response.data;
  }
}

export const staffApi = new StaffAPI();
